// NotificationContext.js
import { createContext, useContext } from 'react';

// Création du contexte de notifications
const NotificationContext = createContext();

// Hook pour utiliser le contexte de notifications
export const useNotificationContext = () => useContext(NotificationContext);

export default NotificationContext;
